<app-stack-layout>
    <h1>Perpetual Licenses</h1>

    <app-empty class="fullsize mt-lg" *ngIf="!isLoading && licenses.length === 0">
        <app-stack-layout class="text-center">
            <h2>No results found</h2>
            <p class="mt-sm">You don't have any perpetual licenses.</p>
            <p class="mt-sm">We currently do not offer perpetual licenses.</p>
        </app-stack-layout>
    </app-empty>
    <div class="mt-lg" *ngIf="licenses.length > 0 && licenses[0].account_id === accountId">
        <table>
            <tr>
                <th>#</th>
                <th>
                    <app-stack-layout class="header" direction="row">
                        <span>Purchased date</span>
                        <app-icon class="ml-xs" icon="down-arrow" size="14px"></app-icon>
                    </app-stack-layout>
                </th>
                <th>Product</th>
                <th>License holder</th>
                <th>License key</th>
                <th class="table-fill-column"></th>
            </tr>
            <tr *ngFor="let license of licenses; let i = index; trackBy: trackLicenseById">
                <td>{{ i + 1 }}</td>
                <td>
                    <app-timestamp [timestamp]="license.purchased_at"></app-timestamp>
                </td>
                <td class="text-no-wrap">{{ license.licenses_count }} x {{ license.name }}</td>
                <td class="text-no-wrap">{{ license.license_holder }}</td>
                <td>
                    <app-license-key *ngIf="license.license_key" [licenseKey]="license.license_key"></app-license-key>
                </td>
                <td class="table-fill-column"></td>
            </tr>
        </table>
    </div>
    <app-spinner class="fullsize" *ngIf="isLoading"></app-spinner>
</app-stack-layout>
